import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class ShowcaseTypes {
  static getProducer: IActionType = new ActionType('SHOWCASE/GET_PRODUCER');
  static getAffiliate: IActionType = new ActionType('SHOWCASE/GET_AFFILIATE');
  static getFresh: IActionType = new ActionType('SHOWCASE/GET_FRESH');
  static getBestsellers: IActionType = new ActionType('SHOWCASE/GET_BEST_SELLERS');
  static getGeneral: IActionType = new ActionType('SHOWCASE/GET_GENERAL');
  static getPhysical: IActionType = new ActionType('SHOWCASE/GET_PHYSICAL');
  static listAdvertisementMaterial: IActionType = new ActionType('SHOWCASE/LIST_AD_MATERIAL');
  static listShowcaseQuestions: IActionType = new ActionType('SHOWCASE/LIST_SHOWCASE_QUESTIONS');
  static askQuestion: IActionType = new ActionType('SHOWCASE/ASK_QUESTION');
  static allRatingsShowcase: IActionType = new ActionType('SHOWCASE/ALL_RATINGS');
  static ratingShowcase: IActionType = new ActionType('SHOWCASE/RATING_SHOWCASE');
  static createAffiliate: IActionType = new ActionType('SHOWCASE/CREATE_AFFILIATE');
  static showcaseProfile: IActionType = new ActionType('SHOWCASE/SHOWCASE_PROFILE');
  static rateProducer: IActionType = new ActionType('SHOWCASE/RATE_PRODUCER');
  static getSubscriptions: IActionType = new ActionType('SHOWCASE/GET_SUBSCRIPTIONS');
}

export default ShowcaseTypes;
